var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.990635 9.36719L3.73357 11.9527C4.0042 12.2078 4.42673 12.2078 4.69736 11.9527L7.4403 9.36719L8.43093 10.303L5.18039 13.3737C4.63884 13.8853 3.79209 13.8853 3.25055 13.3737L0 10.303L0.990635 9.36719Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4403 4.39022L4.69736 1.8047C4.42673 1.54959 4.0042 1.54959 3.73357 1.8047L0.990635 4.39022L0 3.45438L3.25055 0.383708C3.79209 -0.127903 4.63884 -0.127903 5.18039 0.383708L8.43093 3.45439L7.4403 4.39022Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorted);
export default __webpack_public_path__ + "static/media/sorted.0cecc2d31349f431ce1c10a0252d01b9.svg";
export { ForwardRef as ReactComponent };